import React from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";

const PwUpload = () => {
  const sections = [
    {
      heading: "File Upload",
      ui: (
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          
          {/* Single File Upload */}
          <div>
            <label>Single File Upload:</label><br />
            <input type="file" />
          </div>

          {/* Multiple File Upload */}
          <div>
            <label>Multiple File Upload:</label><br />
            <input type="file" multiple />
          </div>

        </div>
      ),
      code: `// Upload single file
await page.setInputFiles('input[type="file"]', 'test.png');

// Upload multiple files
await page.setInputFiles('input[type="file"][multiple]', 
['file1.png', 'file2.png']);`
    }
  ];

  return <PlaywrightTemplate title="FILE UPLOAD" sections={sections} />;
};

export default PwUpload;